import Swiper, {Navigation, Pagination} from 'swiper';

const projectInfoSlider = document.querySelector('.j-project-info-slider');

if (projectInfoSlider) {
    let slider = {};
    const options = {
        modules          : [Navigation, Pagination],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 1,
        slidesOffsetAfter: 0,
        pagination       : {
            el  : '.j-project-info-pagination',
            type: 'custom',
            renderCustom(_, current, total) {
                const newCurrent = current < 10 ? `0${current}` : current;
                const newTotal = total < 10 ? `0${total}` : total;

                return `<span class="slider-control__current">${newCurrent}</span>
                           <span class="slider-control__total">/ ${newTotal}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-project-info-next',
            prevEl: '.j-project-info-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false,
                spaceBetween  : 0
            }
        }
    };

    slider = new Swiper(projectInfoSlider, options);
    slider.init();
}
